<template>
  <BatteryEmissionsAnalyzerTab
    :initial-fields="initialFields"
    :reports="reports"
    :loading="loading"
  />
</template>

<script setup lang="ts">
import BatteryEmissionsAnalyzerTab from '~/components/sustainability/BatteryEmissionsAnalyzerTab.vue'
import { useReports } from '~/composables/useReports'
import type { TMarketServiceConfig } from '~/src/types/markets'
import { ResponseStatus, type TRecord } from '~/src/types/common'

const props = defineProps<{
  market: TMarketServiceConfig
  initialFields: TRecord[]
}>()

const { getBatteryEmissionsAnalyserReports } = useReports()

const { data, status } = await getBatteryEmissionsAnalyserReports(
  props.market.slug,
)

const loading = computed(() => status.value !== ResponseStatus.SUCCESS)
const reports = computed(() => data.value || [])

definePageMeta({ isTab: true, layout: 'services' })

/*-------------------------------------
  SEO
-------------------------------------*/
const { getSeoInfo } = useSeo()
const seo = getSeoInfo({
  title: 'Battery Emissions Analyser',
  description:
    "Benchmark's Battery Emissions Analyser compares carbon emissions associated with battery cells with different chemistries, production locations and raw material sourcing.",
})
useHead(seo)
</script>
